export const load = async ({ data, fetch }) => {
    const result = await fetch(`/api/reviews/likes?building_id=${data.building.uuid}`);
    let { reviewLikeCounts } = await result.json();

    let reviewUuids = data.building.reviews.map((r) => r.uuid).join(',');
    const reviewerNamesResult = await (
        await fetch('/api/reviewers/name?review_uuid=' + reviewUuids)
    ).json();

    const nearbyBuildingsResult = await fetch('/api/v2/search/nearby', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            lat: data.building?.lat,
            long: data.building?.long,
            uuid: data.building?.uuid,
        }),
    });
    let { results: nearbyBuildings } = await nearbyBuildingsResult.json();

    return {
        building: data.building,
        buildingScore: data.buildingScore,
        buildingDetailedScore: data.buildingDetailedScore,
        isAdmin: data.isAdmin,
        isLoggedIn: data.isLoggedIn,
        referralCode: data.referralCode,
        reviewLikes: reviewLikeCounts,
        reviewerNames: reviewerNamesResult.displayNames,
        nearbyBuildings,
    };
};
